import gql from 'graphql-tag';

export const USER_TIMERS = gql`
  query UserTimers($userId: ID) {
    userTimers(userId: $userId) {
      timerId
      lastStartDate
      description
      settings {
        duration
      }
      isCompleted
    }
  }
`;

export const USER_TEMPLATES = gql`
  query UserTemplates($userId: ID, $limit: Int) {
    userTemplates(userId: $userId, limit: $limit) {
      name
      templateId
      timesUsed
    }
  }
`;

export const USER_ROOMS = gql`
  query GetUserRooms($userId: ID) {
    getUserRooms(userId: $userId) {
      rooms {
        roomId
        description
        timers
        lastTimeUsed
        members
        users {
          email
          name
          settings {
            avatar
          }
        }
        settings {
          isPrivate
          backgroundImage
        }
      }

      memberOf {
        roomId
        description
        timers
        lastTimeUsed
        members
        users {
          email
          name
          settings {
            avatar
          }
        }
        settings {
          isPrivate
          backgroundImage
        }
      }
    }
  }
`;
export const USER_TIMERPODS = gql`
  query UserTimerPod($userId: ID!) {
    userTimerPod(userId: $userId) {
      timerPodId
      roomId
      description
      totalCompleted
      isCompleted
      creationDate
      isCompleted
    }
  }
`;

export const USER_NOTIFICATIONS = gql`
  query UserNotifications($userId: ID) {
    userNotifications(userId: $userId) {
      label
      notificationId
      requestingUser
      type
      roomId
      date
    }
  }
`;

export const USER_LOGS = gql`
  query LatestEvents($userId: ID!) {
    latestEvents(userId: $userId) {
      description
      roomId
      date
      ownerId
      userId
      eventType
      room {
        roomId
        description
      }
      user {
        name
        settings {
          avatar
        }
      }
    }
  }
`;

export const USER_CONTRIBUTION = gql`
  query UserContribution($userId: ID, $from: Float, $to: Float) {
    userContribution(userId: $userId, from: $from, to: $to) {
      stats {
        total
        allTimers
        completedTimers
        tasks
      }
      contribution {
        date
        timers
      }
    }
  }
`;

export const FOCUS_MINUTES = gql`
  query FocusMinutes($userId: ID) {
    focusMinutes(userId: $userId) {
      week
      total
      day
      month
    }
  }
`;
